import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list-head',
  templateUrl: './list-head.component.html',
  styleUrls: ['./list-head.component.scss'],
})
export class ListHeadComponent {
  @Input() matIconName!: string;
  @Input() subTitle!: string;
  @Input() title!: string;

  constructor() {}
}
